import React from 'react';
import { Body2, Title4 } from '../../tokens';

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

// TODO: Should use Title5 but the styles don't match figma
export function SectionTitle({ title, subtitle, children }: SectionTitleProps) {
  return (
    <div className="flex flex-row items-center justify-center gap-x-sm p-sm text-on-screen-surface">
      <div className="flex flex-1 flex-col justify-center gap-y-xxs">
        <Title4>{title}</Title4>
        {subtitle && <Body2>{subtitle}</Body2>}
      </div>

      {children}
    </div>
  );
}
